export default __webpack_public_path__ + "static/media/playroompage-status.260974af.svg";